module.exports = __webpack_public_path__ + "img/section-meter-gas-meter-lg.05c59ce7.svg";